import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { ScannerCode, Input, Button } from '../../../components/UI/ComponentsUI';
import { translate, showMessageToastCustom, isNullOrEmpty, configs } from '../../../utils/util';
import { ENUMS } from '../../../utils/constants';
import { onValueChange } from '../../../utils/handleChangeHooks';
import ReceiptList from '../Receipt/ReceiptList';

const ScannerReceiptItem = (props) => {
    const [model, setModel] = useState({ partNumber: '' });
    const [receipts, setReceipts] = useState([]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    useEffect(() => {
        document.getElementById('partNumber').focus();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let receiptFilter = [];
        Object.assign(receiptFilter, props.receipts);
        if (receiptFilter && receiptFilter.length > 0) {
            receiptFilter = props.receipts.filter((f) => f.balance > 0 && !f.checked)
        }
        setReceipts(receiptFilter);
        // eslint-disable-next-line
    }, [props.receipts, props.selectedTab]);

    useEffect(() => {
        if (model.partNumber.length > 8) {
            handleDesenhoChange();
        }
        // eslint-disable-next-line
    }, [model.partNumber]);

    const getListParts = (partnumberCode, partNumberModel) => {
        try {
            const itemsFilter = props.receipts.filter((item) => item.balance > 0 && item.partNumberCode === partnumberCode);
            if (itemsFilter.length > 0) {
                let qdte = 0;
                let mdrType = '';

                if (partNumberModel.length > 43) {
                    qdte = parseInt(partNumberModel.substring(39, 44), 10);
                    mdrType = partNumberModel.substring(44, 48);
                }

                props.createConfirmation(itemsFilter[0], qdte, itemsFilter[0].mdr || mdrType);
                props.onReadItemChange(true);
            } else {
                return;
            }
        } catch (error) {
            showMessageToastCustom(translate('warning', 'general'), error.message || "", 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    const handleDesenhoChange = () => {
        if (!isNullOrEmpty(model.partNumber)) {
            let partnumberCode = "";
            if (model.partNumber.length > 11) {
                partnumberCode = model.partNumber.substring(0, 11);
            } else if (model.partNumber.length <= 11 && model.partNumber.length >= 9) {
                partnumberCode = model.partNumber.padStart(11, "0");
            }

            getListParts(partnumberCode, model.partNumber);
            model.partNumber = ''
            setModel(model);
        }
    }

    const onQrCodeReadHandler = (data) => {
        getListParts(data.substring(0, 11), data);
    }

    const getConfig = () => {
        return configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items)
    }

    const submit = () => {
        const confirmations = [];
        var shed = !Boolean(getConfig()?.shedRequiredPhysicalConfirmation) || props.filter?.truckKanban ? "" : props.sheds.find((i) => i.id === props.user.shed).code;

        props.receiptsGroup.forEach((item) => {
            props.createConfirmation(item, '', item.mdr || '');
            item.dock = props.filter?.truckKanban ? "M01" : props.user.dock;
            item.shed = props.filter?.truckKanban ? item.shed : shed
            item.group = true;
            item.qtItems = item.qme;
            item.mdrType = item.mdr;
            item.mdrTypeOrigin = item.mdr;
            item.type = ENUMS.eTypeConfirmation.Confirmation.value;
            confirmations.push(item);
        });

        props.history.push({
            pathname: `./groupReceipt`,
            state: { receipts: confirmations, truckKanban: props.filter?.truckKanban }
        });
    }

    return (
        <>
            <div className="container-fluid">
                <div className="container" style={{ width: '98%' }}>
                    <div className="card">
                        <div className="card-content" style={{ padding: '0px', paddingTop: '5px' }}>
                            <div className="row">
                                <div style={{ padding: '2px' }}>
                                    <div className="input-field padding col s11">
                                        <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={onQrCodeReadHandler} />
                                        <Input
                                            required
                                            id="partNumber"
                                            name='partNumber'
                                            placeholder={translate('scanner-receipt.partnumber')}
                                            type="text"
                                            value={model.partNumber}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                receipts?.length > 0 &&
                <div id="ReceiptListSearchPartNumber" className="" style={{ marginBottom: '5px' }}>
                    <ReceiptList
                        {...props}
                        id='ReceiptLisSearch'
                        receipts={receipts}
                        group={true} />
                </div>
            }
            <div className="row" style={{ marginBottom: '5px' }}>
                <div className="col s12 lefth">
                    {
                        props.receiptsGroup && props.receiptsGroup.length > 0 && <Button full="true" onClick={submit} text="Recebimento Master CIM" />
                    }
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        filter: state.physicalConfirmationReducer.filter,
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        receiptsGroup: state.physicalConfirmationReducer.receiptsGroup
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createConfirmation: (receiptItem, quantity, mdrType) => {
            dispatch(PhysicalConfirmationService.createConfirmation(receiptItem, quantity, mdrType));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ScannerReceiptItem)));
